<template>

    <tr @click="showModule">
        <td>{{ index +1}}</td>
        <td :class="{'text-success': res.isElected}">{{ res.name }}</td>
        <!--Має з'явитись табличка з кандидатами-->
        <td>{{ res.totalVotesForParty }}</td>
        <td>{{ res.percent }}</td>
        <!--Тут має з'явитись вкладка з округами-->
        <td><span :style="mandatStyle">{{ res.totalMandats
            }} / {{res.okrugMandats}}</span></td>
        <td v-for="r in res.regionResults.length" :key="r"><span :class="parseInt(res.mandats[r-1]) ? 'mandates' : parseInt(res.mandats[r-1]) == 0 ? 'zeroMandates' : 'noMandates' ">{{ res.mandats[r-1]}}</span> {{ res.regionResults[r-1]}}</td>


    </tr>

</template>

<script>
    export default {
        name: "partyResultEach",
        data() {
            return {
                styleHover: false
            }
        },
        props: ['res', 'index', 'maxMandats', 'minMandats'],
        computed: {
            styleObject() {
                    let a = this.res.percent.toFixed(0) * 3 + 100;
                    let c = 100 - this.res.percent.toFixed(0);
                    c = c / 100;
                    c = 1 - c;
                    let b = 'rgb(100,' + a + ', 100,' + c + ')';
                    return {
                        'background-color': b,
                    }
            },


            mandatStyle() {
                if(this.res.isElected == true) {
                    const percents = Math.round(((+this.res.totalMandats - +this.minMandats) / (+this.maxMandats - +this.minMandats)) * 100) / 100;
                    return {
                        'background-color': '#48c71f94',
                        'width': 'calc(35px + (100% - 35px) * ' +  percents + ')',
                        'white-space': 'nowrap',
                        'display': 'block'
                    }
                }else {return ''}
            }
    },

        methods: {
            showModule() {
                this.$emit('showCand');
            }
        },

    }
</script>

<style scoped>
    span {
        padding: 1px 5px;
        /* border-right: 1px solid black; */
    }
    .mandates{
        background-color: #48c71f94;
        border-radius: 10px;
        font-size: 11px;
        margin-right: 5px;
    }
    .zeroMandates{
        background-color: #ccc;
        border-radius: 10px;
        font-size: 11px;
        margin-right: 5px;
    }
    .noMandates{
        margin-left: 14px;
    }
</style>